import React from 'react';
import { Construction, Sparkles } from 'lucide-react';

export const AdminSectionPlaceholder = ({
  title,
  description,
  sections = [],
  note = 'Estructura lista para la siguiente fase de implementación.',
}) => {
  return (
    <section className="ops-panel suite-placeholder-panel" data-testid={`suite-placeholder-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
      <div className="suite-placeholder-hero">
        <div>
          <span className="section-eyebrow">Scaffold listo</span>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div className="suite-placeholder-icon" data-testid="suite-placeholder-icon">
          <Construction size={24} />
        </div>
      </div>

      <div className="suite-placeholder-grid">
        {sections.map((item) => (
          <article key={item} className="suite-placeholder-card" data-testid={`suite-placeholder-item-${item.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
            <Sparkles size={16} />
            <strong>{item}</strong>
          </article>
        ))}
      </div>

      <div className="suite-placeholder-note" data-testid="suite-placeholder-note">
        <p>{note}</p>
      </div>
    </section>
  );
};

export default AdminSectionPlaceholder;